export const GAME_PHASE = {
  unstarted: 'unstarted',
  started: 'started',
  finished: 'finished'
};

export const ROUND_PHASE = {
  guessing: 'guessing',
  guessed: 'guessed'
};

export const LOADING_LOCATIONS = [
  [46.441288, 8.0978813], // Aletschgletscher
  [32.8811034, -106.1686447], // White Sands
  [40.7698642, -73.9790173], // Manhattan
  [-3.3439751,-64.6260472], // Amazon
  [34.2737957, 132.9328517], // Inland Sea
  [47.787516,-124.0090051], // Olympic National Park
  [-22.9055689, -68.3270609], // Valle de la Luna
  [42.1985218,-95.4023319] // Iowa
].map((coords) => ({lat: coords[0], lng: coords[1]}));

export const ROUNDS_PER_GAME = 10;
export const MAX_ROUND_POINTS = 100;
export const MAX_SCORED_DISTANCE_METERS = 10000 * 1000;
export const MIN_SCORED_ZOOM_LEVEL = 5;